import * as R from 'ramda';

export default function SelectRiskControlsForReviewDialogController(
  $rootScope,
  $scope,
  $q,
  ssDialogService,
  loaderService,
  userService,
  vmDataService,
  performControlsReviewDialog,
  selectRiskControlsForReviewDialog,
  completeControlReviewWithNoControlsDialog,
) {
  const vm = this;

  vm.handleSelectRiskControlsForReviewFormSubmit = _handleSelectRiskControlsForReviewFormSubmit;
  vm.handleCloseDialog = _handleCloseDialog;

  function _handleSelectRiskControlsForReviewFormSubmit($event) {
    if ($scope.selectRiskControlsForReviewForm.$valid) {
      _closeDialog().then(() => {
        const newControlReviewTask = getNewControlReviewTask();

        loaderService.showViewLoader = true;
        vmDataService.saveRiskControlReviewTask(newControlReviewTask).then(() => {
          vmDataService.getRiskControlsInfoByProduct(vm.product.productId).then(response => {
            loaderService.showViewLoader = false;
            const currentControlsReviewTask = response.data;

            if (currentControlsReviewTask.riskControls.length > 0) {
              showPerformControlsReviewDialog($event, currentControlsReviewTask);
            } else {
              completeControlReviewWithNoControlsDialog.show(
                $event,
                vm.product,
                vm.vendor,
                selectRiskControlsForReviewDialog,
                vm.riskControlReviewTaskId,
                $rootScope,
              );
            }
          });
        });
      });
    }
  }

  function getNewControlReviewTask() {
    const selectedRiskControls = R.filter(
      R.propEq('isSelected', true),
      vm.product.recommendedRiskControls.concat(
        vm.product.suggestedRiskControls,
        vm.product.optionalRiskControls,
        vm.product.customRiskControls,
      ),
    );

    const newControlReviewTask = {
      riskControlReviewTaskId: vm.riskControlReviewTaskId,
      atCustId: userService.user.atcustId,
      productId: vm.product.productId,
      isActive: true,
      isComplete: false,
      riskControlReviewTaskControls: selectedRiskControls,
    };
    return newControlReviewTask;
  }

  function showPerformControlsReviewDialog($event, currentControlsReviewTask) {
    ssDialogService.dialogs.vendorManagement.performControlsReviewDialog = ssDialogService.alert(
      performControlsReviewDialog.getOptions($event, {
        vendor: vm.vendor,
        product: vm.product,
        currentControlsReviewTask,
        selectRiskControlsForReviewDialog,
      }),
    );
    return ssDialogService.show(ssDialogService.dialogs.vendorManagement.performControlsReviewDialog);
  }

  function _handleCloseDialog() {
    _closeDialog();
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.vendorManagement.selectRiskControlsForReviewDialog);
  }
}

SelectRiskControlsForReviewDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'ssDialogService',
  'loaderService',
  'userService',
  'vmDataService',
  'performControlsReviewDialog',
  'selectRiskControlsForReviewDialog',
  'completeControlReviewWithNoControlsDialog',
];
